export const RQ_PATIENT_HISTORY_ADD = {
  url: 'api/PatientHistory/add',
  method: 'POST',
  auth: true,
};

export const RQ_PATIENT_HISTORY_UPDATE = {
  url: 'api/PatientHistory/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_PATIENT_HISTORY_LOOKUP = {
  url: 'api/PatientHistory/lookup/<%= patienthistoryId %>',
  method: 'GET',
  auth: true,
};

export const RQ_PATIENT_HISTORY_LOOKUP_ALL = {
  url: 'api/PatientHistory/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_PATIENT_HISTORY_DELETE = {
  url: 'api/PatientHistory/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
